export default class _BaseUserProfile {
  class = 'BaseUserProfile';
  props = {};
  component = 'BaseUserProfile';
  error = false;
  value = null;
  additionalFormValue = null;
  hideClearUntilValue = false;
  previousStep = null;
  skipConditionsExists = false;
  skipConditions = {
    value: false,
    stepToGo: null,
  };
  jumpedFrom = null;
  context = null;

  constructor(context, { value, additionalFormValue }) {
    this.class = this.constructor.name;
    this.context = context;
    this.value = value === undefined ? null : value;
    this.additionalFormValue = additionalFormValue || null;
  }

  static get className() {
    return this.name;
  }

  save() {
    this.context.save();
  }
}
